import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';

export class ColumnDateDto extends ColumnFieldTypeObject {
  // todo: the type of dataDto should be updated to be generic
  DateStringCallback: (dataDto: object) => string;
  // These are just the params for angular date pipe
  DateFormat: string;
  TimeZone: string; // Should default to what the local computer has
  Locale: string; // Should default to what the local computer has

  constructor(init?: Partial<ColumnDateDto>) {
    super();
    this.FieldType = ColumnFieldType.Date;
    this.TimeZone = '';
    this.Locale = '';
    Object.assign(this, init);
  }
}
